module.exports = __webpack_public_path__ + "img/add.be9e3c14.svg";